// src/components/ui/PawLogo.jsx
export default function PawLogo({ color = "#8D6E63", size = 40 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M256 224c-79.4 0-192 122.8-192 200.3C64 459.2 90.9 480 128 480h256c37.1 0 64-20.8 64-55.7 0-77.5-112.6-200.3-192-200.3z" fill={color} />
            <path d="M117.4 135.2a64 64 0 1 0 67.1-108.4 64 64 0 0 0-67.1 108.4z" fill={color} />
            <path d="M394.6 135.2a64 64 0 1 0-67.1-108.4 64 64 0 0 0 67.1 108.4z" fill={color} />
            <path d="M181.8 185.9a64 64 0 1 0-97.4 7.5 64 64 0 0 0 97.4-7.5z" fill={color} />
            <path d="M330.2 185.9a64 64 0 1 1 97.4 7.5 64 64 0 0 1-97.4-7.5z" fill={color} />
        </svg>
    );
}
